
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newest",
      function () {
        return require("private-next-pages/newest/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newest"])
      });
    }
  